export class PatientReg {
  Password: string;
  AuthorizedPhone: string;
  TOSAccepted: boolean;
  DobVerified: boolean;
  UserId: number;

  constructor() {
    this.Password = "";
    this.AuthorizedPhone = "";
    this.TOSAccepted = false;
    this.DobVerified = false;
    this.UserId = null;
  }

  getPayload = () => {
    return {
      Password: this.Password,
      AuthorizedPhone: this.AuthorizedPhone,
      TOSAccepted: this.TOSAccepted,
      DobVerified: this.DobVerified,
      UserId: this.UserId
    };
  };
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/models/patient-reg.model.ts